import _ from 'lodash';
import { CLEAR_ERROR, CLOSE_ERROR } from '../actions/types';
import type { Action, Error } from '../../types';

const getErrorMessage = (payload: any): string[]|string => {
  if (payload.response && payload.response.data && payload.response.data.errors) {
     
    const errors = payload.response.data.errors;

    return _.keys(errors).map(key => `${key} ${errors[key]}`);
  }

  return payload.message;
};

export function errorReducer(state: Error, action: Action): object {
  const { type, payload } = action;
  if (_.isEmpty(state)) {
    state = {
      display: false,
      message: '',
      type: '',
    };
  }
  if (type.includes('_REJECTED')) {
    return {
      display: true,
      message: getErrorMessage(payload),
      type,
    };
  }
  if (type === CLOSE_ERROR) {
    return {
      ...state,
      display: false,
    };
  }
  if (type === CLEAR_ERROR) {
    return {
      display: false,
      message: '',
      type: '',
    };
  }

  return state;
}
